import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// The console itself is a standalone page in public/hepbandme, so it can be
// updated by replacing one file and opened on its own.
const CONSOLE_SRC = "/hepbandme/console.html";
const APP_STORE = "https://apps.apple.com/us/app/hepb-me/id6736882788";
const GOOGLE_PLAY = "https://play.google.com/store/apps/details?id=com.deepcvision.hepbme";

const HepbandmeDemo = () => {
  // Starting height until the console reports its real one.
  const [frameHeight, setFrameHeight] = useState(1500);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = "HepB&Me Clinician Demo | Deep-C Vision";

    // Keep the demo out of search results until it is launched publicly.
    const robots = document.createElement("meta");
    robots.name = "robots";
    robots.content = "noindex";
    document.head.appendChild(robots);

    const onMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      if (event.data?.type === "hepbandme-console:height") {
        setFrameHeight(Math.ceil(event.data.height));
      }
    };
    window.addEventListener("message", onMessage);

    return () => {
      document.title = previousTitle;
      robots.remove();
      window.removeEventListener("message", onMessage);
    };
  }, []);

  return (
    <div className="bg-ink pt-28 lg:pt-32">
      <section className="px-6 pt-16 pb-10">
        <div className="max-w-6xl mx-auto">
          <p className="eyebrow mb-6">HepB&amp;Me · For clinicians</p>
          <h1 className="font-display text-[clamp(48px,8vw,96px)] leading-[0.92] tracking-wide text-paper">
            Clinician <span className="text-brand-cyan">demo</span>
          </h1>
          <p className="text-body text-muted max-w-2xl mt-6">
            Try the HepB&amp;Me clinician flow with example results: choose whether the patient is on
            antiviral treatment, select the band for each result, and see the summary and messages the
            app shows. Thresholds and wording match the app, version 1.2.3. This is a demonstration
            only and must not be used for clinical decisions or with patient information.
          </p>
          <div className="flex flex-wrap gap-3 mt-8">
            <a href={APP_STORE} target="_blank" rel="noopener noreferrer" className="btn-ghost">
              App Store
            </a>
            <a href={GOOGLE_PLAY} target="_blank" rel="noopener noreferrer" className="btn-ghost">
              Google Play
            </a>
            <Link to="/projects/hepbme" className="btn-ghost">
              About the app
            </Link>
            <a href={CONSOLE_SRC} target="_blank" rel="noopener noreferrer" className="btn-ghost">
              Open full screen
            </a>
          </div>
        </div>
      </section>

      <section className="px-2 sm:px-6 pb-24">
        <div className="max-w-6xl mx-auto">
          <iframe
            title="HepB&Me clinician demo"
            src={CONSOLE_SRC}
            style={{ height: frameHeight }}
            className="block w-full border border-ink-line rounded-tile bg-[#0E1115]"
          />
        </div>
      </section>
    </div>
  );
};

export default HepbandmeDemo;
